import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';
import { makeRequest } from '@/shared/services/http';
import { IMedication } from '@/shared/types/interfaces/medication';
import HelpArrowIcon from '@/assets/icons/help-arrow.svg';
import HelpArrowRotatedIcon from '@/assets/icons/help-arrow-rotated.svg';
import HelpArrowSmallIcon from '@/assets/icons/help-arrow-small.svg';
import HelpArrowLargeIcon from '@/assets/icons/help-arrow-large.svg';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useCallback } from 'react';
import { AdvancedAutoComplete } from '@/shared/ui/autocomplete/adavanced-autoComplete';

interface IProps {
    onSelect(medication: IMedication): void;
}


const SelectMedication = ({ onSelect }: IProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isExtraSmallMobile = useMediaQuery(theme.breakpoints.down(380));

    const loadMedications = useCallback(
        (query: string, signal: AbortSignal) =>
            makeRequest<IMedication[]>('get', 'prescribables', 'search', {
                params: {
                    term: query,
                    dispensable: true
                }, signal
            }),
        []
    );

    return (
        <AdvancedAutoComplete<IMedication>
            id="select-medication"
            uniqueIdentifier="medicationFinder"
            label=""
            labelClassName="lg:text-xl xl:text-17 2xl:text-xl text-xl font-dmSans"
            labelKey="name"
            inputVariant="advanced"
            popoverInputVariant="advanced"
            popoverTitle="Search for your medication"
            subLabel={
                <i className="font-dmSans text-lg tracking-[0.02rem] lg:text-xl xl:text-17 2xl:text-xl">
                    <span className='font-dmSans text-18 sm:text-20 leading-[130%]'>
                        It's <span className='font-dmSansBold font-bold'>3x faster</span> using voice!
                    </span>
                    {isExtraSmallMobile ? (
                        <img
                            key={1}
                            src={HelpArrowSmallIcon}
                            alt="help arrow small"
                            className="absolute right-[5px] top-[0rem] z-10 w-[15px]"
                        />
                    ) : (
                        <img
                            key={2}
                            src={isMobile ? HelpArrowIcon : HelpArrowLargeIcon}
                            alt="help arrow"
                            className="absolute right-[30px] top-[-0.5rem] z-10 w-[50px] sm:right-[10%] sm:top-[0rem] sm:w-auto xl:right-[12%] xl:w-[100px] 2xl:right-[10%] 2xl:w-auto"
                        />
                    )}
                </i>
            }
            popoverHelper={
                <i className="absolute right-[26px] z-[10] flex items-start font-dmSans text-[1.0625rem] tracking-[0.02rem]">
                    <p className="mr-2 mt-2">
                        It's <b>3x faster</b> <br /> using voice!
                    </p>
                    <img src={HelpArrowRotatedIcon} alt="help arrow" className="w-[53px]" />
                </i>
            }
            placeholder="Type name & dose here"
            loadOptionsList={loadMedications}
            onSelect={onSelect}
        />
    );
};

export default withScrollRestoration(SelectMedication);
